import { CSSProperties } from 'react';
import { px2rem } from '../utils';
import { CommonPropsWithChildren, withNativeProps } from '../utils/native-props';
import './style.less';

export type BadgeProps = CommonPropsWithChildren & {
  bgColor?: CSSProperties['color'];
  content?: React.ReactNode;
  top?: number;
  right?: number;
  fontSize?: number;
};

export const Badge = (props: BadgeProps) => {
  // props style 优先级更高
  const style = {
    '--badge-background-color': props.bgColor,
    '--badge-text-color': props.bgColor ? '#ffffff' : 'var(--v-text-color-dark)',
    '--badge-top': props.top ? px2rem(props.top) : undefined,
    '--badge-right': props.right ? px2rem(props.right) : undefined,
    '--badge-font-size': props.fontSize ? px2rem(props.fontSize) : undefined,
  } as CSSProperties;

  return withNativeProps(
    props,
    <div style={style} className={'v-badge-wrapper'}>
      {props.children}
      <span className="v-badge">{props.content}</span>
    </div>,
  );
};
